var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calender-schedule-detail-comment-preview-component"},[_c('hi-dialog',{attrs:{"title":"First Comment"},on:{"close":function($event){return _vm.close()}}},[_c('div',{staticClass:"text-container"},[_vm._v(_vm._s(_vm.comment))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }